import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import SalesGeneratePickList from 'components/Sales/GeneratePickList';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <SalesGeneratePickList />
      </SiteContent>
    </ContentLayout>
  );
};
